<template>
  <Layout>
    <div class="section content has-text-white">
      <h1>{{ $t('Write MSISDN to login') }}</h1>
      <p><input type="phone" class="input m-sm is-size-4" v-model="phone" style="width:70%">
      <input type="submit" class="m-sm button is-success is-size-4" @click="send" :value="$t('Continue')"></p>
      <p class="is-size-4" style="line-height: 2.5;">
        {{ 'If you did not register for the best games, click here' | translate }} 
        <router-link class="m-sm button is-success is-size-4" :to="{ name: 'LP' }">{{ 'PLAY NOW!' | translate }}</router-link>
      </p>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/GGLogout'


export default {
  name: 'Login',
  data () {
    return {
      phone: ''
    }
  },
  methods: {
    send() {
      const msisdn = this.$store.getters.formatMsisdn(this.phone)
      if (msisdn)
        location.replace(`/nth/identify/${ msisdn }`)
    }
  },
  components: {
    Layout
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangGG/Login.vue